<template>
  <v-navigation-drawer
    class=""
    width="250"
    right
    :mini-variant="miniVariant"
    v-model="isMainMenuActive"
    persistent
    app
    v-if="!isMainMenuHidden"
  >
    <v-toolbar
      flat
      class="transparent"
    >
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img :src="userAvatar">
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ user.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list>
      <template
        value="true"
        v-for="(item, i) in mainMenu"
        v-if="shouldShow(item.roles, user)"
      >
        <v-divider
          v-if="item.divider"
          :key="i"
        ></v-divider>

        <!-- Regular link -->
        <v-list-tile
          v-else-if="item.path"
          :key="item.title"
          :to="item.path"
        >
          <v-list-tile-action>
            <v-badge
              color="red"
              left
              overlap
              v-if="item.eventsBadge && activeEvents.length"
            >
              <span slot="badge">{{ activeEvents.length }}</span>
              <v-icon v-html="item.icon"></v-icon>
            </v-badge>
            <v-icon
              v-html="item.icon"
              v-else
            ></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Function -->
        <v-list-tile
          v-else
          :key="item.title"
          @click="envokeMethodByName(item.click)"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import colors from "vuetify/es5/util/colors";
import shouldShow from "@/utils/shouldShow";
import { camelCase } from 'lodash';

export default {
  data: () => ({
    routeNamesToHideMenu: ["Event"],
    isMainMenuHidden: true,
    mainMenu: [
      { title: "לוח בקרה", icon: "dashboard", path: "/" },
      { title: "אירועים", icon: "event", eventsBadge: true, path: "/events" },
      { title: "מפה", icon: "map", path: "/map" },
      { title: "תיקי מדינה", icon: "flag", path: "/countries" },
      { title: "ארן", icon: "business", path: "/arans" },
      { divider: true },
      { title: "ספקים", icon: "assignment_ind", path: "/partners" },
      { title: "מתורגמנים", icon: "translate", path: "/translators" },
      {
        title: "דו״חות",
        icon: "assessment",
        path: "/reports/duties",
        roles: ["ADMIN", "RESEARCHER"]
      },
      { divider: true },
      {
        title: "הגדרות מערכת",
        icon: "settings",
        path: "/system-setup",
        roles: ["ADMIN", "RESEARCHER"]
      },
      {
        title: "דיווח על תקלה",
        icon: "bug_report",
        click: "openBugReportDialog"
      },
      { divider: true },
      // { title: "הגדרות משתמש", icon: "face", path: "/user-settings" },
      {
        title: "יציאה",
        icon: "logout",
        click: "logout"
      }
      // { divider: true },
      // {
      //   title: 'תצוגת לילה',
      //   icon: 'brightness_high',
      //   click: () => {
      //     self.nightMode = !self.nightMode;
      //   }
      // }
    ]
  }),

  computed: {
    isMainMenuActive: {
      get() {
        return this.$store.getters["isMainMenuActive"];
      },
      set(isActive) {
        this.$store.dispatch("TOGGLE_MAIN_MENU", { isActive });
      }
    },
    miniVariant: {
      get() {
        return this.$store.getters["mainMenuMiniVariant"];
      },
      set(isActive) {
        this.$store.dispatch("SET_MAIN_MENU_MINI_VARIANT", { isActive });
      }
    },
    nightMode: {
      get() {
        return this.$store.getters["nightMode"];
      },
      set(payload) {
        this.$store.dispatch("TOGGLE_NIGHT_MODE", { payload });
      }
    },
    shouldShowMainMenuAutomatically() {
      return this.$store.getters["shouldShowMainMenuAutomatically"];
    },
    activeEvents() {
      return this.$store.getters["events/activeEvents"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    userAvatar() {
      if (this.user.image) {
        return this.user.image;
      } else {
        return `https://ui-avatars.com/api/?name=${
          this.userAvatarName
        }&background=${this.userAvatarColor}&size=80&color=ffffff&rounded=1&length=1`;
      }
    },
    userAvatarName() {
      return this.user.name;
    },
    userAvatarColor() {
      let color = this.user.color;
      if (color) {
        color = camelCase(color)
      } else {
        color = "blue";
      }
      return colors[color].base.substr(1);
    }
  },

  methods: {
    shouldShow,
    envokeMethodByName(name) {
      this[name]();
    },
    getBadgeDataByName(name) {
      return this[name]();
    },
    logout() {
      this.$confirm("האם לצאת?").then(res => {
        if (!res) {
          return;
        }
        this.$store.dispatch("user/SIGN_OUT");
      });
    },
    openBugReportDialog() {
      this.$store.dispatch("bugReport/TOGGLE_BUG_REPORT_DIALOG", true);
    }
  },

  mounted() {},

  watch: {
    "$route.name": {
      handler: function(val) {
        if (this.routeNamesToHideMenu.indexOf(val) !== -1) {
          this.isMainMenuHidden = true;
        } else {
          this.isMainMenuHidden = false;
        }
      },
      immediate: true
    }
  }
};
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/NavigationDrawer.vue